







import { defineComponent } from '@vue/composition-api';

import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { IS_PRIVATE } from '@/common/constant';
import { CONSTANT_URL } from '@/renderer/scripts/http';

export default defineComponent({
  name: 'BaseAgreement',
  props: {
    separator: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const openAgreementPage = (urlType: 'serviceAgreement' | 'privacyAgreement') => {
      const map = {
        serviceAgreement: IS_PRIVATE ? CONSTANT_URL.privateServiceAgreement : CONSTANT_URL.serviceAgreement,
        privacyAgreement: IS_PRIVATE ? CONSTANT_URL.privatePrivacyAgreement : CONSTANT_URL.privacyAgreement,
      };
      dispatchRouter(map[urlType]);
    };
    return { openAgreementPage };
  },
});
